import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom"; // Assuming you're using react-router for navigation
import { RiArrowRightSLine } from "react-icons/ri";
import {
  getRequest,
  putRequest,
  putWithFormData,
} from "../../helpers/api.helper";
import { StepPropsType } from "../../types";
import { useLanguage } from "../../context/LanguageContext";

type DropdownValue = {
  value: string;
  label: string;
};

const Step8 = ({
  bureauId,
  setCurrentStep,
  currentStep,
  steps,
  profileId,
  setCompletedSteps,
}: StepPropsType) => {
  // Initial state values
  const initialFormData = {
    country: "",
    state: "",
    district: "",
    citizenship: "",
  };

  const { t } = useLanguage();

  const [formData, setFormData] = useState(initialFormData);

  // Country, State, and District Data
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [city, setCity] = useState([]);

  const [searchTerm, setSearchTerm] = useState("");
  const [searchTerm2, setSearchTerm2] = useState("");
  const [modalData, setModalData] = useState(null);
  const [modalData2, setModalData2] = useState<any>(null);

  const dropdownOptions: any = {
    country: [
      ...countries.map((country: any) => ({
        value: country.country,
        label: country.country,
      })),
    ],
    state: [
      ...states.map((state: any) => ({
        value: state.state,
        label: state.state,
      })),
    ],
    city: [
      ...city.map((city: any) => ({ value: city.city, label: city.city })),
    ],
  };

  const [selectedOptions2, setSelectedOptions2] = useState<any>({
    country: null,
    state: null,
    city: null,
    citizenship: null,
  });

  const handleSelect = (selectedOption2: any) => {
    setSelectedOptions2({
      ...selectedOptions2,
      [modalData2.key]: selectedOption2,
    });
    closeModal2();
  };

  // const openModal = (key) => setModalData({ key, options: dropdownOptions[key] });
  // const closeModal = () => setModalData(null);

  const openModal2 = (key: any) =>
    setModalData2({ key, options: dropdownOptions[key] });
  const closeModal2 = () => setModalData2(null);

  useEffect(() => {
    if (modalData) {
      setSearchTerm(""); // Reset search term when opening a new modal
    }
  }, [modalData]);

  useEffect(() => {
    if (modalData2) {
      setSearchTerm2(""); // Reset search term when opening a new modal
    }
  }, [modalData2]);

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls the page to the top
  }, []);

  useEffect(() => {
    if (!profileId) return;

    // Wait until master data is loaded
    if (!countries.length || !states.length || !city.length) return;

    const fetchStep8Data = async () => {
      try {
        const res = await getRequest(`/bureau/profile/${profileId.martialId}`);
        if (!res?.data) return;
        const data = res.data;

        setSelectedOptions2((prev: any) => ({
          ...prev,

          country: data.country
            ? { value: data.country, label: data.country }
            : prev.country,

          state: data.state
            ? { value: data.state, label: data.state }
            : prev.state,

          city: data.district
            ? { value: data.district, label: data.district }
            : prev.city,

          citizenship: data.citizenship
            ? { value: data.citizenship, label: data.citizenship }
            : prev.citizenship,
        }));

        setFormData((prev) => ({
          ...prev,
          country: data.country ?? "",
          state: data.state ?? "",
          district: data.district ?? "",
          citizenship: data.citizenship ?? "",
        }));
      } catch (err) {
        console.error("Failed to load Step8 data", err);
      }
    };

    if (bureauId) fetchStep8Data();
  }, [profileId, countries.length, states.length, city.length]);

  const handleSubmit = async (e: any) => {
    e.preventDefault();

    if (!selectedOptions2.country) return alert("Please select Country");
    if (!selectedOptions2.state) return alert("Please select State");
    if (!selectedOptions2.city) return alert("Please select District");

    // Send the form data with updated family property fields
    const formDataToSend = {
      country: selectedOptions2.country?.value || "",
      state: selectedOptions2.state?.value || "",
      district: selectedOptions2.city?.value || "",
      // Including step flags to indicate progress
      step1: 1,
      step2: 1,
      step3: 1,
      step4: 1,
      step5: 1,
      step6: 1,
      step7: 1,
      step8: 1,
    };

    try {
      const response = await putRequest(
        `/bureau/profile/${profileId?.userId}`,
        formDataToSend,
      );

      if (response.success) {
        setCompletedSteps?.((prev) =>
          prev.includes(currentStep) ? prev : [...prev, currentStep],
        );
        if (currentStep < steps.length) {
          setCurrentStep(currentStep + 1);
        }
      } else {
        alert("Failed to update details.");
      }
    } catch (error) {
      console.error("Error updating details:", error);
      alert("An error occurred while updating details.");
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getRequest("/common/profile/step8");
        if (response.success) {
          setCity(response.data.city);
          setCountries(response.data.country);
          setStates(response.data.state);
        }
      } catch (error) {
        console.error("Error fetching cuntries data:", error);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="w-full max-w-lg bg-white shadow-lg rounded-lg">
      <div className="space-y-6 px-4">
        {Object.keys(dropdownOptions).map((key) => (
          <>
            <div className="mb-[-20px]">
              <label className="block text-red-500 font-medium mb-2">
                {t(key)} *
              </label>
            </div>

            <div
              key={key}
              className="flex flex-col w-full border px-3 border-gray-300 py-3 cursor-pointer hover:shadow-lg transition-all rounded-lg"
              onClick={() => openModal2(key)}
            >
              <div className="flex items-center justify-between">
                <span className="text-gray-500 text-md font-medium">
                  {selectedOptions2[key]?.label || `${t("Select")} ${t(key)}`}
                </span>
                <RiArrowRightSLine className="text-3xl text-gray-500 ml-3" />
              </div>
            </div>
          </>
        ))}
        {/* Action Buttons */}
        <div className="flex flex-col-reverse sm:flex-row gap-3 pt-6">
          {/* <button
            onClick={() => {
              setCurrentStep(Math.max(1, currentStep - 1));
            }}
            className="flex-1 px-6 py-3.5 border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:bg-gray-50 transition-colors"
          >
            Previous
          </button> */}
          <button
            onClick={handleSubmit}
            className="flex-1 px-6 py-3.5 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-lg font-semibold hover:from-pink-600 hover:to-purple-700 transition-all shadow-lg"
          >
            {currentStep === steps.length ? t("Submit") : t("Next Step")}
          </button>
        </div>
      </div>
      {modalData2 && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white p-6 rounded-lg max-w-md w-full shadow-lg m-5">
            <h2 className="text-lg font-bold mb-4 capitalize text-center">
              {t("Select")} {t(modalData2.key)}
            </h2>

            {/* Search Bar */}
            <input
              type="text"
              className="w-full px-4 py-2 mb-4 border border-gray-300 rounded focus:outline-none focus:ring focus:ring-blue-200"
              placeholder={`Search ${modalData2.key}`}
              value={searchTerm2}
              onChange={(e) => setSearchTerm2(e.target.value)}
            />

            {/* Options List */}
            <div className="h-64 overflow-y-auto border-t border-b border-gray-200">
              {modalData2.options
                .filter((option: any) =>
                  option.label
                    .toLowerCase()
                    .includes(searchTerm2.toLowerCase()),
                )
                .map((option: any, index: any) => (
                  <div key={index}>
                    <button
                      className="block w-full text-left px-4 py-2 hover:bg-gray-100 transition"
                      onClick={() => handleSelect(option)}
                    >
                      {option.label}
                    </button>
                    <hr className="border-gray-200 mt-3 mb-3" />
                  </div>
                ))}
            </div>

            {/* Close Button */}
            <button
              className="mt-4 w-full px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600 transition"
              onClick={closeModal2}
            >
              {t("Close")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Step8;
